// A JOGOK ELŐFELTÉTELE a jogosultság-szerkesztőkben (szerep és felhasználó) — tiszta függvények, I/O nélkül.
//
// A SZABÁLY (user-döntés): egy modul bármely „erősebb" joga (kezelés, törlés, kiküldés, publikálás, …) a modul
// MEGTEKINTÉS-jogát feltételezi — anélkül a lapot sem nyitná meg (a lista a `.view`-t kéri). A modul a kulcs utolsó
// pont előtti része (`finance.expenses.manage` → `finance.expenses`, `portal.tickets.write` → `portal.tickets`), az
// előfeltétel a `<modul>.view`, HA a katalógusban létezik (a Szolgáltatásoknak, az Eszközöknek nincs ilyen joga).
//
// A szerkesztő pipáláskor bepipálja az előfeltételt is, a megtekintés kivételekor pedig (user-döntés) a modul
// minden erősebb jogát is kiveszi — és mindkettőt kiírja a láblécben, hogy semmi ne változzon csendben. A jogok
// továbbra is egyenként, kifejezetten tárolódnak — a szerveren nincs rejtett „a kezelés jelenti a megtekintést"
// szabály.

/**
 * KIVÉTEL-szabályok: olyan előfeltétel, ami nem a modul saját `.view`-ja. Az `asset_requests.decide` a kezdőlap „Rám vár"
 * sorát az `/assets` listából számolja, ami `asset_inventory.view`-t kér — enélkül a sor zsákutca lenne (a lap sem
 * nyílik meg), ezért a szerkesztő a döntési jog mellé az eszköz-nyilvántartás megtekintését is felajánlja.
 */
const EXTRA_PREREQUISITES: Readonly<Record<string, string>> = {
  'asset_requests.decide': 'asset_inventory.view',
};

/** A kulcs megtekintés-előfeltétele (`<modul>.view`), ha van ilyen jog a katalógusban — különben `null`. */
export function viewPrerequisiteOf(key: string, allKeys: ReadonlySet<string>): string | null {
  const extra = EXTRA_PREREQUISITES[key];
  if (extra !== undefined && allKeys.has(extra)) return extra;
  const dot = key.lastIndexOf('.');
  if (dot <= 0) return null;
  if (key.slice(dot + 1) === 'view') return null;
  const view = `${key.slice(0, dot)}.view`;
  return allKeys.has(view) ? view : null;
}

/** A megtekintés-jogtól FÜGGŐ jogok (a modul erősebb jogai) — a megtekintés kivételekor ezek is kikerülnek. */
export function dependentsOf(viewKey: string, allKeys: readonly string[]): string[] {
  const all = new Set(allKeys);
  return allKeys.filter((k) => viewPrerequisiteOf(k, all) === viewKey);
}

/**
 * Bekapcsolt jogok, amelyeknek az előfeltétele NINCS bekapcsolva — a szerkesztő ezekre figyelmeztet.
 * A párok sorrendje a bemeneté (a hívó rendezett listát ad).
 */
export function missingPrerequisites(
  checked: ReadonlySet<string>,
  allKeys: readonly string[],
): { key: string; requires: string }[] {
  const all = new Set(allKeys);
  const out: { key: string; requires: string }[] = [];
  for (const key of allKeys) {
    if (!checked.has(key)) continue;
    const view = viewPrerequisiteOf(key, all);
    if (view !== null && !checked.has(view)) out.push({ key, requires: view });
  }
  return out;
}
